<template>
    <div class="xbk_voucher_wrap fc ac">
        <img
            src="http://res.dumovie.com/slide/202006/1591940732384.png"
            alt=""
            class="ad"
        />
        <div class="product_list fc ac">
            <div
                class="product_item fr ac"
                v-for="(item, index) in voucherList"
                :key="index"
                @click="viewDetail(item)"
            >
                <img class="product_img" :src="imgBaseUrl + item.logo" alt="" />
                <div class="product_info fc jsb">
                    <h4>{{ item.name }}</h4>
                    <div class="fr ac jsb">
                        <div class="fc">
                            <span class="ori_price"
                                >官方价：￥{{ item.martetprice }}</span
                            >
                            <div class="fr">
                                <span class="price">￥{{ item.price }}</span>
                                <span class="saved"
                                    >省{{
                                        item.martetprice - item.price
                                    }}元</span
                                >
                            </div>
                        </div>
                        <button>立即购买</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            voucherList: [],
        };
    },
    components: {},
    created() {
        this.getVoucherList();
    },
    methods: {
        getVoucherList() {
            this.$post({
                method: "starbucks.coupon.list",
            }).then((res) => {
                this.voucherList = res.data.productList;
            });
        },
        viewDetail(info){
            let infoTxt = encodeURIComponent(JSON.stringify(info));
            this.$router.push({path: "/xbkVoucherDetail", query: {info: infoTxt}})
        }
    },
};
</script>
<style scoped lang="scss">
.xbk_voucher_wrap {
    .ad {
        width: 100%;
        height: 366px;
    }
    .product_list {
        .product_item {
            width: 680px;
            height: 260px;
            background: #fff;
            padding: 40px 30px;
            box-sizing: border-box;
            border-radius: 10px;
            margin-top: 30px;
            .product_img {
                width: 180px;
                height: 180px;
                border-radius: 10px;
                margin-right: 20px;
            }
            .product_info {
                width: calc(100% - 200px);
                height: 180px;
                font-size: 26px;
                .ori_price {
                    font-size: 24px;
                    color: #999;
                    margin-bottom: 8px;
                }
                .price {
                    font-size: 28px;
                    color: #e42f46;
                    margin-right: 12px;
                }
                .saved {
                    font-size: 22px;
                    background: #e42f46;
                    color: #fff;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 15px 15px 15px 5px;
                    padding: 0 10px;
                }
                button {
                    width: 160px;
                    height: 60px;
                    line-height: 60px;
                    background: #306f47;
                    color: #fff;
                    font-size: 28px;
                    border-radius: 10px;
                    padding: 0;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/xbk/xbkVoucher.vue